class UsernamePasswordRegisterInfo {
    username
    password
    repeatedPassword
    captchaText
    captchaToken

    static getRules(context) {
        const passwordValidator = (rule, value, callback) => {
            if (value) {
                if (context.registerInfo.repeatedPassword) {
                    context.$refs["registerForm"].validateField("repeatedPassword");
                }
                callback()
            }
        }

        const repeatedPasswordValidator = (rule, value, callback) => {
            if (value !== context.registerInfo.password) {
                callback(new Error("两次密码输入不一致"))
            } else {
                callback()
            }
        }

        return {
            username: [
                {required: true, trigger: "blur", message: "请输入用户名"},
                {max: 20, trigger: "blur", message: "最多不能超过20个字"}
            ],
            password: [
                {required: true, trigger: "blur", message: "请输入密码"},
                {validator: passwordValidator, trigger: "blur"}
            ],
            repeatedPassword: [
                {required: true, trigger: "blur", message: "请再次输入密码"},
                {validator: repeatedPasswordValidator, trigger: "blur"}
            ],
            captchaText: [
                {required: true, trigger: "blur", message: "请输入图形验证码"},
            ]
        }
    }
}

export default UsernamePasswordRegisterInfo